<cigna-omni-conversation-summary-card
  *ngFor="
    let item of summaryCardList$ | async;
    trackBy: trackByFunc;
    index as i
  "
  [attr.data-omni-qa-summary-card-conversation-newMessages]="item.newMessages"
  [attr.data-omni-qa-summary-card-conversation-state]="item.state"
  [attr.data-omni-qa-summary-card-conversationId]="item.conversationId"
  [attr.data-omni-qa-summary-card-index]="i"
  [body]="item.body"
  [chevronColor]="item.chevronColor"
  [conversationId]="item.conversationId"
  [date]="item.date"
  [icon]="item.icon"
  [iconColors]="item.iconColors"
  [iconData]="item.iconData"
  [isClosed]="item.isClosed"
  [hasNewMessages]="item.newMessages"
  [subject]="item.subject"
  [state]="item.state"
  [context]="item.context"
  [name]="item.agentName || ''"
></cigna-omni-conversation-summary-card>
<ng-container *ngIf="summaryCardList$ | async as summaryCardList">
  <ng-container *ngIf="summaryCardList?.length === 0">
    <div class="message-container">
      <div class="message-box">You have no previous conversations.</div>
    </div>
  </ng-container>
</ng-container>
